import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4 px-3 grid grid-cols-4 gap-3" }
const _hoisted_2 = { class: "py-4 px-3 flex items-center justify-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "bg-white rounded",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_select, {
        placeholder: "Выберите курьера",
        value: _ctx.state.courierId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courierId) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.couriers.list,
        loading: _ctx.data_state.couriers.is_loading,
        failed: _ctx.data_state.couriers.is_failed,
        "error-text": "При получении списка курьеров произошла ошибка",
        label: "fullName",
        "search-by": "fullName",
        "search-without-refresh": "",
        "can-deselect": "",
        onRefresh: _ctx.loadCouriers
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_new_input, {
        type: "date",
        value: _ctx.state.fromDate,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.fromDate) = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_input, {
        type: "date",
        value: _ctx.state.toDate,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.toDate) = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_input, {
        placeholder: "Укажите номер накладной",
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_input, {
        placeholder: "Укажите номер выдачи",
        value: _ctx.state.number,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.number) = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_select, {
        placeholder: "Выберите сектор",
        value: _ctx.state.sectorId,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.sectorId) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.sectors.list,
        loading: _ctx.data_state.sectors.is_loading,
        failed: _ctx.data_state.sectors.is_failed,
        "error-text": "При получении списка секторов произошла ошибка",
        "search-without-refresh": "",
        "can-deselect": "",
        onRefresh: _ctx.loadSectors
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Выберите волну",
        value: _ctx.state.waveId,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.waveId) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.waves.list,
        loading: _ctx.data_state.waves.is_loading,
        failed: _ctx.data_state.waves.is_failed,
        "error-text": "При получении списка волн произошла ошибка",
        label: "title",
        "search-without-refresh": "",
        "can-deselect": "",
        onRefresh: _ctx.loadWaves
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_button, {
        disabled: _ctx.loading || _ctx.disabled,
        class: "NewButton--reset mr-3",
        onClick: _ctx.onFiltersReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_new_button, {
        disabled: _ctx.loading || _ctx.disabled,
        class: "NewButton--search",
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 32))
}